import { render, staticRenderFns } from "./GenderSelector.vue?vue&type=template&id=2f26e9af&scoped=true&"
import script from "./GenderSelector.vue?vue&type=script&lang=js&"
export * from "./GenderSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f26e9af",
  null
  
)

export default component.exports